export const headerMenu = [
    {
        id: '1',
        title: 'Worker Profile',
    },
    {
        id: '2',
        title: 'Training History',
    },
    {
        id: '3',
        title: 'Work Profile',
    },
    {
        id: '4',
        title: 'Vaccination Status',
    },
    {
        id: '5',
        title: 'Financial Information',
    },
]

export const vaccinationCert =
    'https://akm-img-a-in.tosshub.com/indiatoday/images/bodyeditor/202106/IMG-20210615-WA0011-x1141.jpg?qiH1l4ukcwWxLnc8YYHrkF0mzWw7RC20'
